import { SalaryDraftActionTypes } from "models/actionTypes/salaryDraftActionTypes";
import { ReduxConstants } from "utils/constants";

export const salaryDraftAccepted = (id: number): SalaryDraftActionTypes => {
  return {
    type: ReduxConstants.SalaryDraftActions.SALARY_DRAFT_ACCEPTED,
    payload: id,
  };
};

export const salaryDraftRejected = (id: number): SalaryDraftActionTypes => {
  return {
    type: ReduxConstants.SalaryDraftActions.SALARY_DRAFT_REJECTED,
    payload: id,
  };
};

export const salaryDraftForwarded = (id: number): SalaryDraftActionTypes => {
  return {
    type: ReduxConstants.SalaryDraftActions.SALARY_DRAFT_FORWARDED,
    payload: id,
  };
};
